export default __webpack_public_path__ + "static/media/featuredMb.1775244e.png";